// Generated by ReScript, PLEASE EDIT WITH CARE


function empty(array) {
  return array.length === 0;
}

function notEmpty(array) {
  return array.length !== 0;
}

function blankString(string) {
  return string.trim().length === 0;
}

function notBlankString(string) {
  return !blankString(string);
}

export {
  empty,
  notEmpty,
  blankString,
  notBlankString,
}
/* No side effect */
